/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DatabaseTelemetry } from '../models';
// @ts-ignore
import type { IngestTelemetryEventsRequest } from '../models';
// @ts-ignore
import type { ListDatabaseInstancesTelemetryResponse } from '../models';
// @ts-ignore
import type { ListDatabaseTelemetryResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * TelemetryAPIApi - axios parameter creator
 * @export
 */
export const TelemetryAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * GetDatabaseTelemetry returns the telemetry state of a single database
         * @summary Get database telemetry
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} id Database identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telemetryAPIGetDatabaseTelemetry: async (organizationId: string, databaseInstanceId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('telemetryAPIGetDatabaseTelemetry', 'organizationId', organizationId)
            // verify required parameter 'databaseInstanceId' is not null or undefined
            assertParamExists('telemetryAPIGetDatabaseTelemetry', 'databaseInstanceId', databaseInstanceId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('telemetryAPIGetDatabaseTelemetry', 'id', id)
            const localVarPath = `/database-optimizer/telemetry/v1alpha/organizations/{organizationId}/database-instances/{databaseInstanceId}/databases/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseInstanceId"}}`, encodeURIComponent(String(databaseInstanceId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * IngestTelemetryEvents ingests a batch of telemetry events reported by the agent and/or proxy
         * @summary Ingest telemetry events
         * @param {string} organizationId Organization identifier
         * @param {IngestTelemetryEventsRequest} ingestTelemetryEventsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telemetryAPIIngestTelemetryEvents: async (organizationId: string, ingestTelemetryEventsRequest: IngestTelemetryEventsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('telemetryAPIIngestTelemetryEvents', 'organizationId', organizationId)
            // verify required parameter 'ingestTelemetryEventsRequest' is not null or undefined
            assertParamExists('telemetryAPIIngestTelemetryEvents', 'ingestTelemetryEventsRequest', ingestTelemetryEventsRequest)
            const localVarPath = `/database-optimizer/telemetry/v1alpha/organizations/{organizationId}/events`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestTelemetryEventsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ListDatabaseInstancesTelemetry returns the aggregated telemetry state of every database instance of the organization
         * @summary List database instance telemetry
         * @param {string} organizationId Organization identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telemetryAPIListDatabaseInstancesTelemetry: async (organizationId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('telemetryAPIListDatabaseInstancesTelemetry', 'organizationId', organizationId)
            const localVarPath = `/database-optimizer/telemetry/v1alpha/organizations/{organizationId}/database-instances`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ListDatabaseTelemetry returns the telemetry state of every database of a database instance
         * @summary List database telemetry
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telemetryAPIListDatabaseTelemetry: async (organizationId: string, databaseInstanceId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('telemetryAPIListDatabaseTelemetry', 'organizationId', organizationId)
            // verify required parameter 'databaseInstanceId' is not null or undefined
            assertParamExists('telemetryAPIListDatabaseTelemetry', 'databaseInstanceId', databaseInstanceId)
            const localVarPath = `/database-optimizer/telemetry/v1alpha/organizations/{organizationId}/database-instances/{databaseInstanceId}/databases`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseInstanceId"}}`, encodeURIComponent(String(databaseInstanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TelemetryAPIApi - functional programming interface
 * @export
 */
export const TelemetryAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TelemetryAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * GetDatabaseTelemetry returns the telemetry state of a single database
         * @summary Get database telemetry
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} id Database identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telemetryAPIGetDatabaseTelemetry(organizationId: string, databaseInstanceId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatabaseTelemetry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telemetryAPIGetDatabaseTelemetry(organizationId, databaseInstanceId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelemetryAPIApi.telemetryAPIGetDatabaseTelemetry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * IngestTelemetryEvents ingests a batch of telemetry events reported by the agent and/or proxy
         * @summary Ingest telemetry events
         * @param {string} organizationId Organization identifier
         * @param {IngestTelemetryEventsRequest} ingestTelemetryEventsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telemetryAPIIngestTelemetryEvents(organizationId: string, ingestTelemetryEventsRequest: IngestTelemetryEventsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telemetryAPIIngestTelemetryEvents(organizationId, ingestTelemetryEventsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelemetryAPIApi.telemetryAPIIngestTelemetryEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ListDatabaseInstancesTelemetry returns the aggregated telemetry state of every database instance of the organization
         * @summary List database instance telemetry
         * @param {string} organizationId Organization identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telemetryAPIListDatabaseInstancesTelemetry(organizationId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDatabaseInstancesTelemetryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telemetryAPIListDatabaseInstancesTelemetry(organizationId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelemetryAPIApi.telemetryAPIListDatabaseInstancesTelemetry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ListDatabaseTelemetry returns the telemetry state of every database of a database instance
         * @summary List database telemetry
         * @param {string} organizationId Organization identifier
         * @param {string} databaseInstanceId Database instance identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async telemetryAPIListDatabaseTelemetry(organizationId: string, databaseInstanceId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDatabaseTelemetryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.telemetryAPIListDatabaseTelemetry(organizationId, databaseInstanceId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TelemetryAPIApi.telemetryAPIListDatabaseTelemetry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TelemetryAPIApi - factory interface
 * @export
 */
export const TelemetryAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TelemetryAPIApiFp(configuration)
    return {
        /**
         * GetDatabaseTelemetry returns the telemetry state of a single database
         * @summary Get database telemetry
         * @param {TelemetryAPIApiTelemetryAPIGetDatabaseTelemetryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telemetryAPIGetDatabaseTelemetry(requestParameters: TelemetryAPIApiTelemetryAPIGetDatabaseTelemetryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DatabaseTelemetry> {
            return localVarFp.telemetryAPIGetDatabaseTelemetry(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * IngestTelemetryEvents ingests a batch of telemetry events reported by the agent and/or proxy
         * @summary Ingest telemetry events
         * @param {TelemetryAPIApiTelemetryAPIIngestTelemetryEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telemetryAPIIngestTelemetryEvents(requestParameters: TelemetryAPIApiTelemetryAPIIngestTelemetryEventsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.telemetryAPIIngestTelemetryEvents(requestParameters.organizationId, requestParameters.ingestTelemetryEventsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ListDatabaseInstancesTelemetry returns the aggregated telemetry state of every database instance of the organization
         * @summary List database instance telemetry
         * @param {TelemetryAPIApiTelemetryAPIListDatabaseInstancesTelemetryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telemetryAPIListDatabaseInstancesTelemetry(requestParameters: TelemetryAPIApiTelemetryAPIListDatabaseInstancesTelemetryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDatabaseInstancesTelemetryResponse> {
            return localVarFp.telemetryAPIListDatabaseInstancesTelemetry(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * ListDatabaseTelemetry returns the telemetry state of every database of a database instance
         * @summary List database telemetry
         * @param {TelemetryAPIApiTelemetryAPIListDatabaseTelemetryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        telemetryAPIListDatabaseTelemetry(requestParameters: TelemetryAPIApiTelemetryAPIListDatabaseTelemetryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDatabaseTelemetryResponse> {
            return localVarFp.telemetryAPIListDatabaseTelemetry(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for telemetryAPIGetDatabaseTelemetry operation in TelemetryAPIApi.
 * @export
 * @interface TelemetryAPIApiTelemetryAPIGetDatabaseTelemetryRequest
 */
export interface TelemetryAPIApiTelemetryAPIGetDatabaseTelemetryRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIGetDatabaseTelemetry
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIGetDatabaseTelemetry
     */
    readonly databaseInstanceId: string

    /**
     * Database identifier
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIGetDatabaseTelemetry
     */
    readonly id: string
}

/**
 * Request parameters for telemetryAPIIngestTelemetryEvents operation in TelemetryAPIApi.
 * @export
 * @interface TelemetryAPIApiTelemetryAPIIngestTelemetryEventsRequest
 */
export interface TelemetryAPIApiTelemetryAPIIngestTelemetryEventsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIIngestTelemetryEvents
     */
    readonly organizationId: string

    /**
     * 
     * @type {IngestTelemetryEventsRequest}
     * @memberof TelemetryAPIApiTelemetryAPIIngestTelemetryEvents
     */
    readonly ingestTelemetryEventsRequest: IngestTelemetryEventsRequest
}

/**
 * Request parameters for telemetryAPIListDatabaseInstancesTelemetry operation in TelemetryAPIApi.
 * @export
 * @interface TelemetryAPIApiTelemetryAPIListDatabaseInstancesTelemetryRequest
 */
export interface TelemetryAPIApiTelemetryAPIListDatabaseInstancesTelemetryRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIListDatabaseInstancesTelemetry
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIListDatabaseInstancesTelemetry
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIListDatabaseInstancesTelemetry
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for telemetryAPIListDatabaseTelemetry operation in TelemetryAPIApi.
 * @export
 * @interface TelemetryAPIApiTelemetryAPIListDatabaseTelemetryRequest
 */
export interface TelemetryAPIApiTelemetryAPIListDatabaseTelemetryRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIListDatabaseTelemetry
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIListDatabaseTelemetry
     */
    readonly databaseInstanceId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIListDatabaseTelemetry
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof TelemetryAPIApiTelemetryAPIListDatabaseTelemetry
     */
    readonly pageCursor?: string
}

/**
 * TelemetryAPIApi - object-oriented interface
 * @export
 * @class TelemetryAPIApi
 * @extends {BaseAPI}
 */
export class TelemetryAPIApi extends BaseAPI {
    /**
     * GetDatabaseTelemetry returns the telemetry state of a single database
     * @summary Get database telemetry
     * @param {TelemetryAPIApiTelemetryAPIGetDatabaseTelemetryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelemetryAPIApi
     */
    public telemetryAPIGetDatabaseTelemetry(requestParameters: TelemetryAPIApiTelemetryAPIGetDatabaseTelemetryRequest, options?: RawAxiosRequestConfig) {
        return TelemetryAPIApiFp(this.configuration).telemetryAPIGetDatabaseTelemetry(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * IngestTelemetryEvents ingests a batch of telemetry events reported by the agent and/or proxy
     * @summary Ingest telemetry events
     * @param {TelemetryAPIApiTelemetryAPIIngestTelemetryEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelemetryAPIApi
     */
    public telemetryAPIIngestTelemetryEvents(requestParameters: TelemetryAPIApiTelemetryAPIIngestTelemetryEventsRequest, options?: RawAxiosRequestConfig) {
        return TelemetryAPIApiFp(this.configuration).telemetryAPIIngestTelemetryEvents(requestParameters.organizationId, requestParameters.ingestTelemetryEventsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ListDatabaseInstancesTelemetry returns the aggregated telemetry state of every database instance of the organization
     * @summary List database instance telemetry
     * @param {TelemetryAPIApiTelemetryAPIListDatabaseInstancesTelemetryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelemetryAPIApi
     */
    public telemetryAPIListDatabaseInstancesTelemetry(requestParameters: TelemetryAPIApiTelemetryAPIListDatabaseInstancesTelemetryRequest, options?: RawAxiosRequestConfig) {
        return TelemetryAPIApiFp(this.configuration).telemetryAPIListDatabaseInstancesTelemetry(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ListDatabaseTelemetry returns the telemetry state of every database of a database instance
     * @summary List database telemetry
     * @param {TelemetryAPIApiTelemetryAPIListDatabaseTelemetryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TelemetryAPIApi
     */
    public telemetryAPIListDatabaseTelemetry(requestParameters: TelemetryAPIApiTelemetryAPIListDatabaseTelemetryRequest, options?: RawAxiosRequestConfig) {
        return TelemetryAPIApiFp(this.configuration).telemetryAPIListDatabaseTelemetry(requestParameters.organizationId, requestParameters.databaseInstanceId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

